const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initGA() {
  if (initialized || !GA_MEASUREMENT_ID) return;
  initialized = true;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID, { send_page_view: true });
}

export function trackPageView(path) {
  if (!initialized || !window.gtag) return;
  window.gtag("config", GA_MEASUREMENT_ID, { page_path: path });
}

export function hasConsent() {
  return localStorage.getItem("cookieConsent") === "accepted";
}

export function initIfConsented() {
  if (hasConsent()) initGA();
}
